import CenteredSpinner from "@/components/CenteredSpinner";
import generalMailsIcons from "@/components/generalMailsIcons";
import EmailView from "@/components/mailsList/EmailView";
import MailSource from "@/domain/enums/MailSource";
import useGetMailsList from "@/hooks/mails/useGetMailsList";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const ViewTitle = ({ id }: { id: MailSource }) => {
    const { t } = useTranslation();
    const icon = generalMailsIcons.find((i) => i.id === id);

    return (
        <>
            <div className="text-left">
                <h2 className="text-main-title flex w-full items-center justify-start gap-2 truncate text-start font-display text-3xl">
                    {icon && (
                        <img
                            alt=""
                            className="h-6 w-6 shrink-0"
                            src={icon.icon}
                        />
                    )}
                    <span className="truncate">
                        {t(`navbar.mainMenu.${id}`)}
                    </span>
                </h2>
            </div>
            <hr className="my-2" />
        </>
    );
};

const GeneralEmails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const path = location.pathname;
    const urlSource = path.split("/").pop();
    const inboxFolder = Object.values(MailSource).includes(
        urlSource as MailSource,
    )
        ? (urlSource as MailSource)
        : undefined;

    if (!inboxFolder) {
        navigate("/404");
    }

    const {
        isLoading,
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
        flattenedMails,
        updateVersion,
    } = useGetMailsList(inboxFolder!);

    const { data: userProfile } = useGetUserProfile();

    if (!userProfile) {
        return <CenteredSpinner />;
    }

    return (
        <EmailView
            displayMode={
                userProfile.settings.displayPreferences.emailDisplayMode
            }
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoading}
            listId={inboxFolder!}
            loadNextPage={fetchNextPage}
            mails={flattenedMails}
            title={<ViewTitle id={inboxFolder!} />}
            updateVersion={updateVersion}
        />
    );
};

export default GeneralEmails;
